import React from 'react';
import InputNumber from '@base/lib/InputNumber';
import cn from 'classnames';

type ProdQtyProps = {
    className?: string;
    value: number;
    onChange: (qty: number) => void;
    max?: number;
    disabled?: boolean;
};

const ProdQty: React.FC<ProdQtyProps> = (props) => {
    const { className, onChange, value, max, ...restProps } = props;
    return (
        <InputNumber
            tabIndex={0}
            className={cn('g-qty', className)}
            value={value}
            onChange={qty => onChange(Number(qty))}
            min={1}
            max={max}
            {...restProps}
        />
    )
};

export default ProdQty;